/**
 * Helper util to replace all href/src URLs with
 * agnostic protocols to support both HTTP/HTTPS
 */

const agnostifyUrl = (text: string): string => text.replace(/(?!'|")http(s?):\/\//gi, '//')

export default agnostifyUrl
